export default "__VITE_ASSET__BAAIiPOz__"